import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        Personvernerklæring
      </Typography>

      <Typography variant="body1" paragraph>
        Vi er opptatt av våre brukeres personvern og denne personvernerklæringen handler om hvordan vi samler inn og bruker informasjon om besøkende på løsninger.
        Erklæringen inneholder informasjon du har krav på når det samles inn opplysninger fra nettstedet vårt (personopplysningsloven § 19),
        og generell informasjon om hvordan vi behandler personopplysninger (personopplysningsloven § 18, 1. ledd).
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box mb={2}>
        <Typography variant="h6">Kontaktdetaljer</Typography>
        <Typography variant="body2">
          Virksomhetens navn: FMB Concept AS / Fargerike Majorstuen<br />
          Organisasjonsnummer: NO 997 818 776 MVA<br />
          Adresse: Sørkedalsveien 10, 0369 OSLO<br />
          Kontakt oss: <a href="mailto:post@fabconcept.no">post@fabconcept.no</a>
        </Typography>
      </Box>

      <Typography variant="caption" display="block" gutterBottom>
        Sist oppdatert: 10. oktober 2024
      </Typography>

      <Divider sx={{ my: 3 }} />

      {[
        {
          title: '1. Hvilke personopplysninger vi samler inn og hvorfor',
          content:
            'Vi samler inn personopplysninger, som navn, e-postadresser og annen kontaktinformasjon, til tilby og forbedre tjenestene våre, kommunisere med brukere og administrere brukerkontoer. Informasjon samles inn når brukere registrerer seg, foretar kjøp eller samhandler med nettstedet vårt.',
        },
        {
          title: '2. Bruk av din personlige informasjon',
          content:
            'Vi bruker personopplysninger for å oppfylle våre forretningsforpliktelser, for eksempel å behandle transaksjoner, sende nyhetsbrev og tilby kampanjer. Vi kan også bruke data for å forbedre analyser brukeropplevelse.',
        },
        {
          title: '3. Kontroll over dine personopplysninger',
          content:
            'Brukere kan få tilgang til og endre sine personlige data gjennom kontoinnstillingene. Du kan be om å slette dataene dine ved å kontakte oss. Vi sørger for at dataene dine håndteres sikkert og er forpliktet til å opprettholde de høyeste personvernstandardene.',
        },
        {
          title: '4. Misbruk av brukerkontoen din',
          content:
            'Hvis vi oppdager misbruk eller uautorisert aktivitet på kontoen din, vil vi ta nødvendige handlinger for å beskytte dataene dine og kan suspendere eller avslutte kontoen din.',
        },
        {
          title: '5. Nyhetsbrev',
          content:
            'Hvis du abonnerer på vårt nyhetsbrev, vil vi bruke e-postadressen din til å sende deg regelmessige oppdateringer og tilbud. Du kan melde deg av når som helst ved å klikke på koblingen "Avslutt abonnement" i e-posten.',
        },
        {
          title: '6. Endringer i denne personvernerklæringen',
          content:
            'Vi kan oppdatere denne personvernerklæringen etter behov for å gjenspeile endringer i vår praksis eller for juridiske eller regulatoriske årsaker. Eventuelle endringer vil bli lagt ut på denne siden.',
        },
        {
          title: '7. Kontaktinformasjon',
          content:
            'Hvis du har spørsmål om vår personvernerklæring, vennligst kontakt oss på post@fabconcept.no.',
        },
      ].map((section, index) => (
        <Box key={index} mb={4}>
          <Typography variant="h6" gutterBottom>
            {section.title}
          </Typography>
          <Typography variant="body1">{section.content}</Typography>
        </Box>
      ))}
    </Container>
  );
};

export default PrivacyPolicy;
